module.exports = __webpack_public_path__ + "static/media/petrus.e083ac1a.jpeg";